import topbar from "topbar";

topbar.config({
  barColors: { "0": "#28a7ff", ".5": "#0a71eb", "1": "#0f5abe" },
  shadowColor: "rgba(0, 0, 0, .3)",
});

window.addEventListener("phx:page-loading-start", (_info) => topbar.show(300));
window.addEventListener("phx:page-loading-stop", (_info) => topbar.hide());
